export default "__VITE_ASSET__00557474__"